module.exports = __webpack_public_path__ + "img/2022_SC.55e0d222.jpg";